























































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxLoadPanel } from 'devextreme-vue';
import {
    DxChart,
    DxSeries,
    DxLegend,
    DxSize,
    DxCommonSeriesSettings,
    DxValueAxis,
    DxAdaptiveLayout,
    DxLabel,
    DxGrid,
    DxArgumentAxis,
    DxTick,
    DxCommonAxisSettings,
    DxFont,
    DxTooltip,
} from 'devextreme-vue/chart';
import { WebStorageStateStore } from 'oidc-client';

import { localize } from '@/core/filters';
import { ClientDate } from '@/core/helpers';
import {
    IResourceByType,
    ITechnicChartRecord,
} from '@/dto/operationalPlanSummary/index';
import {
    IResourcesData,
    IExpandedState,
    LocalizationKeys,
    Formatter,
    IMeasureFormattingOptions,
    ResourceRecord,
    ILoadingState,
    StackData
} from '../classes';
import { prepareData } from '@/core/components/uploader/utils';
import { ResourceStackRecord } from '../classes/ResourceStackRecord';
import { type } from 'jquery';

interface IChartData {
    label: string;
    used: number;
    available: number;
    deficit: number;
}

@Component({
    components: {
        DxChart,
        DxSeries,
        DxLegend,
        DxSize,
        DxCommonSeriesSettings,
        DxValueAxis,
        DxAdaptiveLayout,
        DxLabel,
        DxGrid,
        DxArgumentAxis,
        DxTick,
        DxCommonAxisSettings,
        DxFont,
        DxTooltip,
        DxLoadPanel,
    },
})
export default class ResourceChart extends Vue {
    private static readonly EXPANDED_HEIGHT: number = 182;
    private static readonly COLLAPSED_HEIGHT: number = 127;
    private static idCounter: number = 0;

    @Prop({ required: true }) public resourcesData?: IResourcesData & IExpandedState & ILoadingState;
    @Prop({ required: false }) public resourceTypes?: string[];

    public LocalizationKeys = LocalizationKeys;

    private readonly id: number = ++ResourceChart.idCounter;

    private readonly measureFormattingOptions: IMeasureFormattingOptions = {
        separator: '',
        numberFormattingOptions: {
            useGrouping: true,
        },
        measures: [
            {
                power: 0,
                measure: '',
            },
        ],
    };

    private mounted(): void {
        if (!this.resourcesData) {
            throw new Error('resourcesData is not set');
        }
    }

    private customizeItems(items: any[]) {
        items.forEach(x => x.text = this.localize(x.text));
        return items;
    }

    private localize(text: string): string {
        return localize('OPS_' + text);
    }

    private get isLoaded(): boolean {
        return this.resourcesData!.isLoaded;
    }

    private get diagramHeight(): number {
        return this.resourcesData!.isExpanded
            ? ResourceChart.EXPANDED_HEIGHT
            : ResourceChart.COLLAPSED_HEIGHT;
    }

    private get resourcesValues(): StackData[] {
        const resourceRecords = this.resourcesData?.resources || [];

        const result: StackData[] = this.prepareStackData(resourceRecords);

        return result;
    }

    private prepareStackData(
        resourceRecords: ResourceStackRecord[]
    ): StackData[] {
        const result: StackData[] = [];
        for (const record of resourceRecords) {
            const label = record.operDayName.format({ day: '2-digit' });
            const resultRecord = new StackData(label, record.resourcesByType);
            result.push(resultRecord);
        }
        return result;
    }

    private customizeTooltip(pointInfo: {
        seriesName: string;
        originalValue: number;
        total: number;
    }): { html: string } {
        let value: number;
        value = pointInfo.originalValue;

        const strValue = Formatter.numberToMeasureString(
            value,
            this.measureFormattingOptions
        );
        const html = `<div class="s-tooltip"><span class="value">${this.localize(pointInfo.seriesName)}: ${strValue}</span></div>`;

        return { html };
    }
}
